import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

export const cancelSalesOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/sales-orders/:id/cancel',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/sales-orders/:id/cancel' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

export const cancelSalesOrdersResponse: Json = {
    title: 'RESPONSE',
    json: {
        "id": 9,
        "number": "10012",
        "carrier": {
            "id": 3,
            "name": "UPS",
            "service": {
                "id": 1,
                "name": "Next Day Air"
            }
        },
        "fobPointName": "Origin",
        "paymentTerms": {
            "id": 4,
            "name": "Net 30"
        },
        "customer": {
            "id": 28,
            "name": "Bike Bargains"
        },
        "vendorPoNumber": "",
        "customerPoNumber": "",
        "customerContact": "justin",
        "salesperson": {
            "id": 1,
            "name": "admin"
        },
        "deliverTo": "timmy",
        "revisionNumber": 17,
        "lastModified": {
            "username": "admin",
            "dateLastModified": "2025-04-17T10:54:49.924-06"
        },
        "dateCreated": "2024-07-14T00:00:00.000-06",
        "dateScheduled": "2024-08-04T00:00:00.000-06",
        "totalTax": "0",
        "totalPrice": "375",
        "mcTotalTax": "0",
        "mcTotalPrice": "375",
        "totalIncludesTax": false,
        "locationGroup": {
            "id": 5,
            "name": "SLC"
        },
        "note": "",
        "url": "",
        "email": "bikes@example.com",
        "phone": "801-932-1101",
        "shipToAddress": {
            "name": "timmy",
            "street": "246 Bike Street",
            "city": "Aloha",
            "state": "OR",
            "postalCode": "97007",
            "country": "UNITED STATES"
        },
        "billToAddress": {
            "name": "Bike Bargains",
            "street": "246 Bike Street",
            "city": "Aloha",
            "state": "OR",
            "postalCode": "97007",
            "country": "UNITED STATES"
        },
        "status": "Cancelled",
        "class": {
            "id": 1,
            "name": "None"
        },
        "shipTerms": "Prepaid & Billed",
        "type": "Standard",
        "soItems": [
            {
                "id": 13,
                "product": {
                    "id": 26,
                    "name": "B201",
                    "description": "Premium Brake Cables"
                },
                "type": {
                    "id": 10,
                    "name": "Sale"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "lineNumber": 1,
                "customerPartNumber": "",
                "unitPrice": "25",
                "totalTax": "0",
                "totalPrice": "125",
                "mcTotalTax": "0",
                "mcTotalPrice": "0",
                "taxRate": {
                    "id": 1,
                    "name": "None",
                    "rate": 0.0
                },
                "dateScheduled": "2024-07-14T08:54:22.000-06",
                "revision": "",
                "note": "",
                "status": "Cancelled",
                "quantity": "5",
                "quantityFulfilled": "0",
                "quantityPicked": "0",
                "class": {
                    "id": 1,
                    "name": "None"
                },
                "customFields": []
            },
            {
                "id": 14,
                "product": {
                    "id": 26,
                    "name": "B201",
                    "description": "Premium Brake Cables"
                },
                "type": {
                    "id": 10,
                    "name": "Sale"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "lineNumber": 2,
                "customerPartNumber": "",
                "unitPrice": "25",
                "totalTax": "0",
                "totalPrice": "125",
                "mcTotalTax": "0",
                "mcTotalPrice": "0",
                "taxRate": {
                    "id": 1,
                    "name": "None",
                    "rate": 0.0
                },
                "dateScheduled": "2024-07-21T08:54:22.000-06",
                "revision": "",
                "note": "",
                "status": "Cancelled",
                "quantity": "5",
                "quantityFulfilled": "0",
                "quantityPicked": "0",
                "class": {
                    "id": 1,
                    "name": "None"
                },
                "customFields": []
            },
            {
                "id": 15,
                "product": {
                    "id": 26,
                    "name": "B201",
                    "description": "Premium Brake Cables"
                },
                "type": {
                    "id": 10,
                    "name": "Sale"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "lineNumber": 3,
                "customerPartNumber": "",
                "unitPrice": "25",
                "totalTax": "0",
                "totalPrice": "125",
                "mcTotalTax": "0",
                "mcTotalPrice": "0",
                "taxRate": {
                    "id": 1,
                    "name": "None",
                    "rate": 0.0
                },
                "dateScheduled": "2024-08-04T08:54:22.000-06",
                "revision": "",
                "note": "",
                "status": "Cancelled",
                "quantity": "5",
                "quantityFulfilled": "0",
                "quantityPicked": "0",
                "class": {
                    "id": 1,
                    "name": "None"
                },
                "customFields": []
            }
        ],
        "customFields": [
            {
                "id": 32,
                "name": "Commerce Order Identity 2",
                "value": "",
                "type": "Long Text"
            },
            {
                "id": 35,
                "name": "ShipExpress SO Return Tracking",
                "value": "",
                "type": "Long Text"
            },
            {
                "id": 20,
                "name": "Custom",
                "value": "",
                "type": "Text"
            },
            {
                "id": 30,
                "name": "Commerce Order Identity 1",
                "value": "",
                "type": "Long Text"
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'cancel-sales-order',
    title: 'Cancel a sales order',
    description: 'Cancels the sales order with the specified ID.',
    endpoint: {
        verb: 'POST',
        path: '/sales-orders/:id/cancel',
        tooltip: 'Cancel a sales order',
    },
    attributes: [],
    requestObject: cancelSalesOrderRequest,
    responseObject: cancelSalesOrdersResponse,
};

export default data;
